module.exports = "../../app/cells/components/modals/login_register_modal/account_create_modal.erb";